import React from 'react';
import { ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-8 md:py-16">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16">
          {/* Left: Logo + mission */}
          <div className="md:w-2/5 flex flex-col items-center md:items-start text-center md:text-left">
            <Link to="/" onClick={scrollToTop}>
              <img
                src="/ChatGPT_Image_Sep_20,_2026,_07_14_14_PM.png"
                alt="Monday Night Group"
                className="h-16 md:h-20 w-auto mb-4"
              />
            </Link>
            <p className="text-sm md:text-base text-gray-400 leading-relaxed max-w-sm">
              To disciple men in Christ through weekly gatherings, doing life together, and a reverent study of Scripture.
            </p>
            <p className="text-sm text-gray-500 mt-3">Monday Night Group 501(c)(3)</p>
          </div>

          {/* Right: Link columns */}
          <div className="md:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-6 md:gap-8 text-center md:text-left md:justify-items-end">
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-3 md:mb-5">Pages</h3>
              <ul className="space-y-2 md:space-y-3 text-sm md:text-base">
                <li>
                  <Link to="/" className="hover:text-white transition-colors duration-300">Home</Link>
                </li>
                <li>
                  <a href="/#about" className="hover:text-white transition-colors duration-300">About Us</a>
                </li>
                <li>
                  <Link to="/reading" className="hover:text-white transition-colors duration-300">Reading</Link>
                </li>
                <li>
                  <Link to="/events" className="hover:text-white transition-colors duration-300">Events</Link>
                </li>
                <li>
                  <a href="/#contact" className="hover:text-white transition-colors duration-300">Join</a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-3 md:mb-5">More</h3>
              <ul className="space-y-2 md:space-y-3 text-sm md:text-base">
                <li>
                  <Link to="/partnerships" className="hover:text-white transition-colors duration-300">Partnerships</Link>
                </li>
                <li>
                  <a href="/#contact" className="hover:text-white transition-colors duration-300">Get Involved</a>
                </li>
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <h3 className="text-sm font-semibold uppercase tracking-wider text-white mb-3 md:mb-5">Connect</h3>
              <p className="text-sm md:text-base text-gray-400">
                Join us every Monday<br />
                7:00 PM - 9:00 PM CST
              </p>
            </div>
          </div>
        </div>
        
        <hr className="border-gray-700 my-6 md:my-8" />
        
        <div className="flex items-center justify-between">
          <p className="text-sm md:text-base">&copy; {new Date().getFullYear()} Monday Night Group. All rights reserved.</p>
          
          <button 
            onClick={scrollToTop}
            className="bg-gray-800 hover:bg-gray-700 text-white p-2 md:p-3 rounded-full transition duration-300"
            aria-label="Scroll to top"
          >
            <ArrowUp className="h-4 w-4 md:h-5 md:w-5" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;